export const TITLE = "【公式】アニメ特化型クラウドファンディング＆ふるさと納税｜アニメファンド";
export const DESCRIPTION = "アニメや聖地を応援したい想いを叶える";
export const KEYWORDS = "クラウドファンディング,アニメ,アニメファンド";
export const OG_TITLE = "アニメ特化型クラウドファンディング＆ふるさと納税｜アニメファンド";
export const OG_SITENAME = "アニメファンド";
